<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Add new contact</h1>

  <app-contact-form (submit)="onSubmit($event)"></app-contact-form>
</app-base-modal>
